import { MessageCircle } from "lucide-react";
import { GENERAL_ENQUIRY } from "@/lib/store";

export const WhatsAppFab = () => (
  <a href={GENERAL_ENQUIRY} target="_blank" rel="noopener noreferrer" aria-label="Chat with RamVilas on WhatsApp" data-testid="whatsapp-fab"
     className="wa-pulse fixed bottom-4 right-4 z-50 flex h-14 items-center gap-2 rounded-full bg-[#25D366] pl-4 pr-5 font-semibold text-[#0B3B1F] shadow-2xl transition-transform duration-300 hover:scale-105 md:hidden">
    <MessageCircle className="h-6 w-6" /> WhatsApp
  </a>
);
